import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import getSortAsQueryString from './helpers/getSortAsQueryString';
import useShallowSearchParams from './useShallowSearchParams';
import { getPathnameWithoutPageNumber } from '@utils/slug/getPathnameWithoutPageNumber';
import { SortValues } from '@business/gql/graphql';

function useSort() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { setShallowSearchParams } = useShallowSearchParams();

  const pathnameWithoutPageNumber = getPathnameWithoutPageNumber(pathname);
  return (sort: SortValues) => {
    const sortParams = getSortAsQueryString({ sort, searchParams });

    const href = `${pathnameWithoutPageNumber}?${sortParams}`;
    setShallowSearchParams(href, sortParams);
    router.replace(`${pathnameWithoutPageNumber}?${sortParams}`, {
      scroll: false,
    });
  };
}

export default useSort;
